import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c6a4b020&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=c6a4b020&scoped=true&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=c6a4b020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a4b020",
  null
  
)

export default component.exports